/** Human message from an RTK Query / Underpin error. RTK rejections are plain objects, not Error. */
export function portalActionError(err: unknown, fallback: string): string {
  if (err instanceof Error && err.message.trim()) return err.message;
  if (!err || typeof err !== 'object') return fallback;
  const data = (err as { data?: unknown }).data;
  if (typeof data === 'string' && data.trim()) return data;
  if (data && typeof data === 'object') {
    const record = data as Record<string, unknown>;
    for (const key of ['message', 'errorMessage', 'error-details', 'detail']) {
      const value = record[key];
      if (typeof value === 'string' && value.trim()) return value;
    }
  }
  return fallback;
}
